import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRequest, postRequest } from "../apis/ApiInstence";

const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const persistUser = (payload) => {
  try {
    localStorage.setItem("user", JSON.stringify(payload));
  } catch {
    // ignore storage errors
  }
};

const normalizeUser = (data) => {
  if (!data) return null;
  return data.response ? data : { response: data };
};

export const signin = createAsyncThunk(
  "user/signin",
  async (credentials, { rejectWithValue }) => {
    try {
      const normalizedEmail =
        credentials?.email || credentials?.username || "";
      const payload = {
        email: String(normalizedEmail).trim().toLowerCase(),
        password: credentials?.password || "",
      };
      const res = await postRequest("customers/login", payload);
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Login failed"
      );
    }
  }
);

export const getoneuser = createAsyncThunk(
  "user/getoneuser",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getRequest(`customers/one/${id}`);
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Unable to fetch user"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    ...normalizeUser(getStoredUser()),
    isLogin: Boolean(getStoredUser()),
    message: "",
    loading: false
  },
  reducers: {
    updateProfile: (state, action) => {
      state.response = {
        ...(state.response || {}),
        ...(action.payload?.data || {})
      };
      const normalized = normalizeUser(state);
      persistUser(normalized?.response || normalized);
    },
    logout: (state) => {
      state.response = null;
      state.isLogin = false;
      state.message = "";
      persistUser(null);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signin.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(signin.fulfilled, (state, action) => {
        state.loading = false;
        const payload =
          action.payload?.data ||
          action.payload?.response ||
          action.payload?.user ||
          action.payload;
        const normalized = normalizeUser(payload);
        state.response = normalized?.response || null;
        state.isLogin = Boolean(state.response);
        state.message = action.payload?.message || "";
        if (state.response) {
          persistUser(state.response);
        }
      })
      .addCase(signin.rejected, (state, action) => {
        state.loading = false;
        state.isLogin = false;
        state.message = action.payload || "Login failed";
      })
      .addCase(getoneuser.fulfilled, (state, action) => {
        const payload = action.payload?.data || action.payload;
        const normalized = normalizeUser(payload);
        state.response = normalized?.response || state.response;
        if (state.response) {
          persistUser(state.response);
        }
      });
  }
});

export const { updateProfile, logout } = userSlice.actions;
export default userSlice.reducer;
